import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import Cta from '~/components/atoms/Cta.vue';
export default {
  name: 'OpeningSelection',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    Cta: Cta
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    title: {
      type: Object,
      required: true
    },
    titleColor: {
      type: String,
      default: ''
    },
    subtitle: {
      type: Object,
      required: true
    },
    subtitleColor: {
      type: String,
      default: ''
    },
    withIcon: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary'
    },
    textBtn: {
      type: String,
      default: ''
    }
  }
};